import { ActionTree } from "vuex";
import { StateInterface } from "src/store";
import { IdomReactionStateInterface } from "./state";
import API from "src/services/api/api";

const actions: ActionTree<IdomReactionStateInterface, StateInterface> = {
  async fetchReactions(
    { commit },
    pagination?: { count: number; page: number },
  ) {
    try {
      const { items, count } = await API.idom.get_queue_messages(
        "manual_sending",
        {},
        pagination?.count || 25,
        pagination?.page || 1,
      );
      commit("setReactions", items);
      commit("setTotal", count);
    } catch (e) {}
  },
};

export default actions;
